module.exports = __webpack_public_path__ + "img/dashboard.ed65da3a.svg";